import React, { useState, useEffect } from "react";
import { db, auth } from "./firebaseConfig";
import { collection, getDocs, getDoc, deleteDoc, query, where, doc, updateDoc, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import Logout from "./Logout";
import OrderDeactivateButton from "./OrderDeactivate";


const Admin = () => {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showCartPopup, setShowCartPopup] = useState(false);
  const [user, setUser] = useState(null);
  const [productStatus, setProductStatus] = useState({
      orangen: true,
      zitronen: true,
      mandarinen: true,
      oliveoil: true,
    });
  const [homepageText, setHomepageText] = useState("");
  const [filterPaid, setFilterPaid] = useState("all");      // all / paid / unpaid
const [filterPickedUp, setFilterPickedUp] = useState("all"); // all / picked / notpicked
const [sortDate, setSortDate] = useState("newest"); // newest / oldest


  const navigate = useNavigate();

  // Bestellungen aus Firestore abrufen
  const fetchOrders = async () => {
    const q = searchQuery
      ? query(collection(db, "orders"), 
      where("customer.name".toLowerCase(), ">=", searchQuery),
      where("customer.name".toLowerCase(), "<=", searchQuery + '\uf8ff'))
      : query(collection(db, "orders"),
      orderBy("customer.name", "asc"));


    try {
      const querySnapshot = await getDocs(q);
      const ordersList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setOrders(ordersList);
    } catch (error) {
      console.error("Fehler beim Abrufen der Bestellungen:", error);
    }
  };

  const filteredOrders = orders
  .filter(order =>
    `${order.customer?.name} ${order.customer?.surname}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  )
  .filter(order => {
    if (filterPaid === "paid") return order.bezahlt === true;
    if (filterPaid === "unpaid") return order.bezahlt === false;
    return true;
  })
  .filter(order => {
    if (filterPickedUp === "picked") return order.abgeholt === true;
    if (filterPickedUp === "notpicked") return order.abgeholt === false;
    return true;
  })
  .sort((a, b) => {
    const dateA = a.timestamp?.seconds || 0;
    const dateB = b.timestamp?.seconds || 0;
    return sortDate === "newest" ? dateB - dateA : dateA - dateB;
  });


  // Alle Bestellungen löschen
const deleteAllOrders = async () => {
  const confirmed = window.confirm("⚠️ Bist du sicher, dass du ALLE Bestellungen löschen willst?");

  if (!confirmed) return;

  try {
    const q = collection(db, "orders");
    const querySnapshot = await getDocs(q);

    const deletePromises = querySnapshot.docs.map((d) =>
      deleteDoc(doc(db, "orders", d.id))
    );

    await Promise.all(deletePromises);

    setOrders([]); // UI leeren
    alert("Alle Bestellungen wurden gelöscht.");
  } catch (error) {
    console.error("Fehler beim Löschen aller Bestellungen:", error);
    alert("Fehler beim Löschen der Bestellungen.");
  }
};


  const fetchHomepageText = async () => {
    try {
      // Referenz auf das Dokument "homepage" in der Collection "settings"
      const docRef = doc(db, "settings", "homepage");
  
      // Dokument abrufen
      const docSnap = await getDoc(docRef);
  
      if (docSnap.exists()) {
        // Falls das Dokument existiert → Text auslesen
        const data = docSnap.data();
        console.log("Homepage Text:", data.homepagetext);
        setHomepageText(data.homepagetext); // oder deinen State damit setzen
      } else {
        console.log("Kein Dokument 'homepage' gefunden!");
      }
    } catch (error) {
      console.error("Fehler beim Abrufen des Homepage-Texts:", error);
    }
  };

// Firestore-Daten laden
  const fetchProductStatus = async () => {
    try {
      const docRef = doc(db, "settings", "products");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setProductStatus(docSnap.data());
      }
    } catch (error) {
      console.error("Fehler beim Laden des Produktstatus:", error);
    }
  };

// Firestore-Daten aktualisieren (z. B. per Klick)
  const toggleProduct = async (key) => {
    try {
      const newStatus = !productStatus[key];
      setProductStatus((prev) => ({ ...prev, [key]: newStatus }));

      const docRef = doc(db, "settings", "products");
      await updateDoc(docRef, { [key]: newStatus });
    } catch (error) {
      console.error("Fehler beim Ändern des Produktstatus:", error);
    }
  };

// Startseitentext speichern
const saveHomepageText = async () => {
  try {
    await updateDoc(doc(db, "settings", "homepage"), {
      homepagetext: homepageText,
    });
    alert("Text gespeichert!");
  } catch (error) {
    console.error("Fehler beim Speichern des Startseitentextes:", error);
  }
};

  /* get DocumentId from Dataset where id is set */
  const getDocumentIdFromValueId = async (idValue) => {
    try {
      const q = query(collection(db, "orders"), where("id", "==", idValue))
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        const documentId = querySnapshot.docs[0].id; // Gets the first matching document
        return documentId;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error retrieving document:", error);
    }
  };

  useEffect(() => {
    fetchHomepageText();
    fetchProductStatus();
    fetchOrders();
  }, [searchQuery]); // Neue Abfrage, wenn sich die Suche ändert

  // Popup-Handling
  const openCartPopup = (order) => {
    setSelectedOrder(order);
    setShowCartPopup(true);
  };

  const closeCartPopup = () => {
    setShowCartPopup(false);
    setSelectedOrder(null);
  };

  // Update-Handler für den bezahlt-Status
  const handlePaidStatusChange = async (orderId, currentStatus) => {
    try {
      const documentID = await getDocumentIdFromValueId(orderId);
      if (documentID) {
      // Datenbank-Update
      const orderRef = doc(db, "orders", documentID);
      await updateDoc(orderRef, { bezahlt: !currentStatus });
      }
      // Lokale Liste aktualisieren
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? { ...order, bezahlt: !currentStatus } : order
        )
      );
    } catch (error) {
      console.error("Fehler beim Aktualisieren des bezahlt-Status:", error);
    }
  };

  // Update-Handler für den bezahlt-Status
  const handleAbgeholtStatusChange = async (orderId, currentAbgeholtStatus) => {
    try {
      const documentID = await getDocumentIdFromValueId(orderId);
      if (documentID) {
      // Datenbank-Update
      const orderRef = doc(db, "orders", documentID);
      await updateDoc(orderRef, { abgeholt: !currentAbgeholtStatus });
      }
      // Lokale Liste aktualisieren
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === orderId ? { ...order, abgeholt: !currentAbgeholtStatus } : order
        )
      );

    } catch (error) {
      console.error("Fehler beim Aktualisieren des abgeholt-Status:", error);
    }
  };

  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser); // Set the user state when logged in
      } else {
        setUser(null); // Set user to null when logged out
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  if (user === null) {
    navigate('/login');
  }

    const breakdown = {
      orangen: { 8: 0, 16: 0 },

      zitronen: { 1: 0, 2: 0, 5: 0, 8: 0, 16: 0 },
      mandarinen: { 1: 0, 2: 0, 5: 0, 8: 0, 16: 0 },
      oliveoil: { flaschen: 0, kanister: 0},
    };


  orders.forEach((orderData) => {
    orderData.order.forEach((o) => {
      const amount = Number(o.amount);
        if (o.productId === 1) breakdown.orangen[amount]++;
        if (o.productId === 2) breakdown.zitronen[amount]++;
        if (o.productId === 3) breakdown.mandarinen[amount]++;
        if (o.productId === 4) {
        if (amount === 5) breakdown.oliveoil.kanister++;
        else if (amount === 4.5) breakdown.oliveoil.flaschen += 6;
        else breakdown.oliveoil.flaschen++;
        }
    });
  });
  const flaschenKarton = breakdown.oliveoil.flaschen / 6;


  let productAmounts = {};
  let flaschen = 0;
  let kanister = 0;

  
  orders.forEach(orderData => {
    orderData.order.forEach(order => {
        const productId = order.productId;
        const amount = parseFloat(order.amount); // sicherstellen, dass amount als Zahl behandelt wird
        if (productAmounts[productId]) {
            productAmounts[productId] += amount;
        } else {
            productAmounts[productId] = amount;
        }

        if(productId === 4){
          if(amount === 5){
            kanister++;
          } 
          else if(amount === 4.5){
            flaschen += 6;
          }
           else {
            flaschen++;
          }
        }
    })     
});


  return ( 
    <div className="p-6">
      <Logout /> <OrderDeactivateButton />
<div className="my-6 p-4 bg-gray-100 rounded-lg shadow-md">
      <h2 className="text-lg font-bold mb-4">Produkte verwalten</h2>
      <div className="grid grid-cols-2 gap-3">
        {Object.entries(productStatus).map(([key, value]) => (
          <button
            key={key}
            onClick={() => toggleProduct(key)}
            className={`px-4 py-2 rounded text-white ${
              value ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
            }`}
          >
            {key.charAt(0).toUpperCase() + key.slice(1)}: {value ? "aktiv" : "inaktiv"}
          </button>
        ))}
      </div>
    </div>

{/* === STARTSEITE TEXT === */}
<details className="my-6 bg-white p-4 rounded-lg shadow">
<summary className="cursor-pointer text-xl font-semibold mb-3">Startseitentext bearbeiten</summary>
<div className="mt-3">
<textarea
value={homepageText}
onChange={(e) => setHomepageText(e.target.value)}
className="w-full border rounded p-2 h-24"
/>
<button
onClick={saveHomepageText}
className="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
>
Speichern
</button>
</div>
</details>

<details className="my-6 bg-white p-4 rounded-lg shadow">
  <summary className="cursor-pointer text-2xl font-bold">
    Admin - Bestellübersicht
  </summary>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 my-4 mt-4">

  {/* Orangen */}
  <div className="bg-white p-4 rounded shadow">
    <p>Total Kilo Orangen:</p>
    <b>{productAmounts[1] ?? 0} kg = {((productAmounts[1] ?? 0) / 16).toFixed(2)} Harassen</b>
    <div className="mt-2">
      {Object.entries(breakdown.orangen).map(([kg, count]) => {
        const notPickedUp = orders.reduce((sum, order) => {
          if (order.abgeholt) return sum;
          const product = order.order.find(
            (item) => item.productId === 1 && parseFloat(item.amount) === parseFloat(kg)
          );
          return sum + (product ? 1 : 0);
        }, 0);

        return (
          <p key={kg}>
            {kg} kg: <span className="text-green-600"><b>{count}x</b></span>, 
            <span className="text-red-600"> {notPickedUp} offen</span>
          </p>
        );
      })}
    </div>
  </div>

  {/* Zitronen */}
  <div className="bg-white p-4 rounded shadow">
    <p>Total Kilo Zitronen:</p>
    <b>{productAmounts[2] ?? 0} kg = {((productAmounts[2] ?? 0) / 16).toFixed(2)} Harassen</b>
    <div className="mt-2">
      {Object.entries(breakdown.zitronen).map(([kg, count]) => {
        const notPickedUp = orders.reduce((sum, order) => {
          if (order.abgeholt) return sum;
          const product = order.order.find(
            (item) => item.productId === 2 && parseFloat(item.amount) === parseFloat(kg)
          );
          return sum + (product ? 1 : 0);
        }, 0);

        return (
          <p key={kg}>
            {kg} kg: <span className="text-green-600"><b>{count}x</b></span>, 
            <span className="text-red-600"> {notPickedUp} offen</span>
          </p>
        );
      })}
    </div>
  </div>

  {/* Mandarinen */}
  <div className="bg-white p-4 rounded shadow">
    <p>Total Kilo Mandarinen:</p>
    <b>{productAmounts[3] ?? 0} kg = {((productAmounts[3] ?? 0) / 16).toFixed(2)} Harassen</b>
    <div className="mt-2">
      {Object.entries(breakdown.mandarinen).map(([kg, count]) => {
        const notPickedUp = orders.reduce((sum, order) => {
          if (order.abgeholt) return sum;
          const product = order.order.find(
            (item) => item.productId === 3 && parseFloat(item.amount) === parseFloat(kg)
          );
          return sum + (product ? 1 : 0);
        }, 0);

        return (
          <p key={kg}>
            {kg} kg: <span className="text-green-600"><b>{count}x</b></span>, 
            <span className="text-red-600"> {notPickedUp} offen</span>
          </p>
        );
      })}
    </div>
  </div>

  {/* Olivenöl */}
  <div className="bg-white p-4 rounded shadow">
    <p>Total Olivenöl:</p>
    <b>{productAmounts[4] ?? 0} L = {flaschen} Flaschen, {kanister} Kanister</b>
    <div className="mt-2">
      <p>Kartons (6×0.75L): {flaschenKarton.toFixed(2)} Kartons</p>
      <p>Kanister (5L): {kanister} Kanister</p>
    </div>
  </div>

  {/* Gesamtberechnung */}
  <div className="bg-white p-4 rounded shadow col-span-1 lg:col-span-2">
    {(() => {
      const totalKg =
        (productAmounts[1] ?? 0) +
        (productAmounts[2] ?? 0) +
        (productAmounts[3] ?? 0);

      const totalHarassen = totalKg / 16;
      const totalPaletten = totalKg / 1024;

      const totalCHF = orders.reduce((sum, order) => {
        const orderTotal = order.order.reduce((s, item) => s + item.amount * item.price, 0);
        return sum + orderTotal;
      }, 0);

      const totalOpenCHF = orders.reduce((sum, order) => {
        if (order.bezahlt) return sum;
        const orderTotal = order.order.reduce((s, item) => s + item.amount * item.price, 0);
        return sum + orderTotal;
      }, 0);

      return (
        <div className="mt-3 space-y-2">
          <p>
            <b>Total Kilo:</b> {totalKg} kg <br /> 
            <b>Total Harassen (16 kg):</b> {totalHarassen.toFixed(2)} Harassen<br />
            <b>Total Paletten:</b> {totalPaletten.toFixed(2)} Paletten
          </p>

          <p className="mt-4 border-t pt-3">
            <b>Total CHF:</b> <span className="text-green-600">{totalCHF.toFixed(2)} CHF </span><br />
            <b>Noch offen:</b> <span className="text-red-600">{totalOpenCHF.toFixed(2)} CHF</span>
          </p>
        </div>
      );
    })()}
  </div>

</div>

</details>

      {/* Suchfeld */}
      <input
        type="text"
        placeholder="Nach Kundenname suchen..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="border rounded-lg p-2 mb-4 w-full max-w-md mr-2"
      />            <button onClick={deleteAllOrders} className="bg-red-500 text-white px-4 py-2 mb-4 rounded">Alle Bestellungen löschen</button>
      {/* Filter */}
<div className="flex flex-wrap gap-2 mb-4">

  {/* Filter Bezahlt */}
  <select
    value={filterPaid}
    onChange={(e) => setFilterPaid(e.target.value)}
    className="border p-2 rounded-lg"
  >
    <option value="all">Alle</option>
    <option value="paid">Bezahlt</option>
    <option value="unpaid">Nicht bezahlt</option>
  </select>

  {/* Filter Abgeholt */}
  <select
    value={filterPickedUp}
    onChange={(e) => setFilterPickedUp(e.target.value)}
    className="border p-2 rounded-lg"
  >
    <option value="all">Alle</option>
    <option value="picked">Abgeholt</option>
    <option value="notpicked">Nicht abgeholt</option>
  </select>

  {/* Sortierung Datum */}
  <select
    value={sortDate}
    onChange={(e) => setSortDate(e.target.value)}
    className="border p-2 rounded-lg"
  >
    <option value="newest">Neuste zuerst</option>
    <option value="oldest">Älteste zuerst</option>
  </select>

</div>

      {/* Responsive Bestellungen Tabelle / Cards */}
<div className="w-full">
  {/* Desktop Table */}
  <div className="hidden md:block">
    <table className="table-auto w-full bg-white shadow-md rounded-lg">
      <thead>
        <tr className="bg-gray-200">
          <th className="p-3 text-left">Kunde</th>
          <th className="p-3 text-left">Telefon</th>
          <th className="p-3 text-left">Ort</th>
          <th className="p-3 text-left">Bezahlt</th>
          <th className="p-3 text-left">Abgeholt</th>
          <th className="p-3 text-left">Zeit</th>
          <th className="p-3 text-left">Aktion</th>
        </tr>
      </thead>
      <tbody>
        {filteredOrders.map((order) => (
          <tr key={order.id} className="border-t">
            <td className="p-3">{order.customer?.name} {order.customer?.surname}</td>
            <td className="p-3">{order.customer?.phone}</td>
            <td className="p-3">{order.customer?.city}</td>
            <td className="p-3">
              <input
                className="w-6 h-6"
                type="checkbox"
                checked={order.bezahlt}
                onChange={() => handlePaidStatusChange(order.id, order.bezahlt)}
              />
            </td>
            <td className="p-3">
              <input
                className="w-6 h-6"
                type="checkbox"
                checked={order.abgeholt}
                onChange={() => handleAbgeholtStatusChange(order.id, order.abgeholt)}
              />
            </td>
            <td className="p-3">
              {new Date(order.timestamp?.seconds * 1000).toLocaleString()}
            </td>
            <td className="p-3">
              <button
                onClick={() => openCartPopup(order)}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Bestellung
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Mobile Cards */}
  <div className="md:hidden space-y-4">
    {filteredOrders.map((order) => (
      <div key={order.id} className="bg-white shadow-md rounded-lg p-4 border">
        <p><b>Kunde:</b> {order.customer?.name} {order.customer?.surname}</p>
        <p><b>Telefon:</b> {order.customer?.phone}</p>
        <p><b>Ort:</b> {order.customer?.city}</p>

        <div className="flex items-center justify-between mt-2">
          <span><b>Bezahlt:</b></span>
          <input
            type="checkbox"
            className="w-6 h-6"
            checked={order.bezahlt}
            onChange={() => handlePaidStatusChange(order.id, order.bezahlt)}
          />
        </div>

        <div className="flex items-center justify-between mt-2">
          <span><b>Abgeholt:</b></span>
          <input
            type="checkbox"
            className="w-6 h-6"
            checked={order.abgeholt}
            onChange={() => handleAbgeholtStatusChange(order.id, order.abgeholt)}
          />
        </div>

        <p className="mt-2"><b>Zeit:</b> {new Date(order.timestamp?.seconds * 1000).toLocaleString()}</p>

        <button
          onClick={() => openCartPopup(order)}
          className="bg-blue-500 w-full text-white mt-3 py-2 rounded"
        >
          Bestellung
        </button>
      </div>
    ))}
  </div>
</div>


      {/* Warenkorb-Popup */}
      {showCartPopup && selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-xl font-bold mb-4">Bestellung von {selectedOrder.customer?.name} {selectedOrder.customer?.surname}</h2>
            <ul>
              {selectedOrder.order.map((item, index) => (
                <li key={index} className="border-b p-2">
                  {item.productId === 4 ? (
                <>
                  {item.amount} L {item.name} = {(item.amount * item.price).toFixed(2)} CHF
                </>
              ) : (
                <>
                  {item.amount} kg {item.name} = {(item.amount * item.price).toFixed(2)} CHF
                </>
              )}
                </li>
              ))}
              <li className="border-t text-lg font-bold p-2">
                Total: {selectedOrder.order.reduce((sum, item) => sum + (item.amount * item.price), 0).toFixed(2)} CHF
              </li>
            </ul>
            <button onClick={closeCartPopup} className="mt-4 bg-red-500 text-white px-4 py-2 rounded">
              Schliessen
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
